import { Component, type ReactNode } from "react";
import { ApiErrorState } from "./ApiErrorState";

interface State {
  readonly error: unknown;
  readonly failed: boolean;
}

/** UX-28: isolates one home card — a render crash shows that card's error + Retry only. */
export class CardBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null, failed: false };

  static getDerivedStateFromError(error: unknown): State {
    return { error, failed: true };
  }

  override render() {
    if (this.state.failed) {
      return (
        <ApiErrorState
          error={this.state.error}
          onRetry={() => this.setState({ error: null, failed: false })}
        />
      );
    }
    return this.props.children;
  }
}
